module.exports = __webpack_public_path__ + "static/media/monster.c899511c.png";